import { h } from "omi";

export function KeyIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" fill="none">
      <path
        d="M11.3333 6c0-.3413-.1302-.6825-.3905-.9428A1.3291 1.3291 0 0 0 10 4.6667M10 10c2.2091 0 4-1.7909 4-4 0-2.2091-1.7909-4-4-4-2.2091 0-4 1.7909-4 4 0 .1825.0122.362.0359.538.0389.2894.0583.4342.0452.5257-.0136.0954-.031.1468-.078.2309-.0451.0807-.1246.1603-.2837.3193l-3.407 3.407c-.1153.1153-.173.173-.2142.2402a.6676.6676 0 0 0-.0798.1927C2 11.5306 2 11.6121 2 11.7752v1.1581c0 .3734 0 .5601.0727.7027a.6667.6667 0 0 0 .2913.2913C2.5066 14 2.6933 14 3.0667 14h1.6v-1.3333H6v-1.3334h1.3333l1.0528-1.0527c.159-.1591.2386-.2386.3193-.2837.0841-.047.1355-.0644.2309-.078.0915-.0131.2363.0063.5257.0452.176.0237.3556.0359.538.0359Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
